import React, { createContext, useContext, useEffect, useRef, useState, useCallback } from "react";
import api from "@/lib/api";

const Ctx = createContext(null);
export const useOnboarding = () => useContext(Ctx);

export function OnboardingProvider({ children }) {
  const [data, setData] = useState({});
  const [docs, setDocs] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [createdProject, setCreatedProject] = useState(null);
  const saveTimer = useRef(null);
  const dataRef = useRef({});

  useEffect(() => { dataRef.current = data; }, [data]);

  useEffect(() => {
    (async () => {
      try {
        const { data: draft } = await api.get("/onboarding/draft");
        setData((prev) => { const merged = { ...prev, ...(draft.data || {}) }; dataRef.current = merged; return merged; });
        if (draft.project_id) {
          try { const { data: p } = await api.get(`/projects/${draft.project_id}`); setCreatedProject(p); } catch {}
        }
      } catch {}
      try { const { data: d } = await api.get("/onboarding/documents"); setDocs(d); } catch {}
      setLoaded(true);
    })();
  }, []);

  const persist = useCallback((next, step) => {
    clearTimeout(saveTimer.current);
    saveTimer.current = setTimeout(() => {
      api.put("/onboarding/draft", { data: next, current_step: step }).catch(() => {});
    }, 500);
  }, []);

  const setField = useCallback((k, v, step) => {
    setData((prev) => { const next = { ...prev, [k]: v }; dataRef.current = next; persist(next, step); return next; });
  }, [persist]);

  const setStep = useCallback((step) => { api.put("/onboarding/draft", { current_step: step }).catch(() => {}); }, []);

  const flush = useCallback(async () => {
    clearTimeout(saveTimer.current);
    try { await api.put("/onboarding/draft", { data: dataRef.current }); } catch {}
  }, []);

  const uploadDoc = async (file, category) => {
    const fd = new FormData(); fd.append("file", file); fd.append("category", category);
    const { data: rec } = await api.post("/onboarding/documents", fd);
    setDocs((d) => [rec, ...d]);
    return rec;
  };
  const removeDoc = async (id) => { await api.delete(`/onboarding/documents/${id}`); setDocs((d) => d.filter((x) => x.id !== id)); };

  const createProject = async () => {
    await flush();
    const { data: p } = await api.post("/onboarding/create-project");
    setCreatedProject(p);
    return p;
  };

  return (
    <Ctx.Provider value={{ data, setField, setData, setStep, docs, uploadDoc, removeDoc, createProject, createdProject, loaded }}>
      {children}
    </Ctx.Provider>
  );
}
